import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { TextField, CircularProgress, MuiThemeProvider } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as actions from 'components/TrustCenter/store/actions';
import { FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME } from 'components/TrustCenter/TrustCenterMuiTheme';
import { SPINNER_THEME } from 'components/TrustCenter/VisibilityConnection/ConnectionWizard/AddConnectionMUITheme';
import ClearIcon from '@material-ui/icons/Clear';
import { isEmptyList } from 'components/Common/Utils/StringUtils';

const ConnectionTypeSearch = (props) => {
    const { accountTypes, isAccountTypeLoaded, updateSelectedAccountType, getAccountTypes } = props;

    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);

    const [userInput, setUserInput] = useState('');

    useEffect(() => {
        if (isEmptyList(accountTypes)) {
            getAccountTypes();
        }
    }, []);

    useEffect(() => {
        return () => {
            setUserInput('');
        };
    }, []);

    useEffect(() => {
        if (isAccountTypeLoaded) {
            setOptions([...accountTypes]);
        }
    }, [isAccountTypeLoaded]);

    const handleSelectedOption = (selectedOption, reason) => {
        if (reason === 'select-option') {
            setUserInput(selectedOption);
            updateSelectedAccountType(selectedOption);
        } else {
            updateSelectedAccountType('');
        }
    };

    return (
        <MuiThemeProvider theme={FILLED_INPUT_AUTO_COMPLETE_FIELD_THEME}>
            <Autocomplete
                id="connection-type"
                open={open}
                inputValue={userInput}
                onOpen={() => {
                    setOpen(true);
                }}
                onClose={() => {
                    setOpen(false);
                }}
                getOptionSelected={(option, value) => option === value}
                getOptionLabel={(option) => option}
                options={options}
                loading={!isAccountTypeLoaded}
                loadingText={
                    <MuiThemeProvider theme={SPINNER_THEME}>
                        <CircularProgress />
                    </MuiThemeProvider>
                }
                clearOnBlur={false}
                noOptionsText="(No record found)"
                onChange={(event, selectedOption, reason) =>
                    handleSelectedOption(selectedOption, reason)
                }
                closeIcon={
                    <ClearIcon
                        onClick={() => {
                            setUserInput('');
                        }}
                        fontSize="small"
                    />
                }
                renderInput={(params) => (
                    <TextField
                        required
                        margin="normal"
                        {...params}
                        label="Select a connection Type"
                        variant="filled"
                        onChange={(event) => {
                            setUserInput(event.target.value);
                        }}
                    />
                )}
            />
        </MuiThemeProvider>
    );
};

const mapStateToProps = (state) => {
    return {
        accountTypes: state.connection.accountTypes,
        isAccountTypeLoaded: state.connection.isAccountTypeLoaded,

        session: state.session.sessionValue
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAccountTypes: () => dispatch(actions.getAccountTypes()),
        updateSelectedAccountType: (accountType) =>
            dispatch(actions.updateSelectedAccountType(accountType))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ConnectionTypeSearch));
